import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { blogPostServices } from "../../../APIServices/SitePilotManagement/BlogManagement/blogPostServices";
import UseToggle from "../../../Hooks/UseToggle";
import { useEffect, useState } from "react";
import PostDetails from "./PostDetails";
import { BiCategory } from "react-icons/bi";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { RxCalendar } from "react-icons/rx";
import Moment from "react-moment";

const BlogSection = ({ themeColor, servicesSection, sendNotification }) => {
  const toggles = UseToggle();
  const [postData, setPostData] = useState("");
  const [blogPosts, setBlogPosts] = useState([]);
  const getPublicBlogPostList = async () => {
    let data = await blogPostServices.getPublicBlogPostList(
      "publish",
    );
    setBlogPosts(data?.data || []);
  };

  useEffect(() => {
    getPublicBlogPostList();
  }, []);
  return (
    <div style={{background: `linear-gradient(360deg, ${themeColor} -700%, #eef2ff30)`,}}>
      <Container className="py-5">
        <h2 className="fw-bold text-center mb-5">Latest Blogs</h2>
        <Row className="g-4">
          {blogPosts.map((post) => (
            <Col md={4} key={post.postId}>
              <Card className="border-0 shadow-sm rounded-4 h-100">
                <Card.Img
                  variant="top"
                  style={{ height: 200, objectFit: "cover" }}
                  src={"https://i.pravatar.cc/?img=1"}
                />
                <Card.Body>
                  <div className="hstack justify-content-between mb-2">
                    <div className="hstack gap-2">
                      <p style={{ fontSize: 14 }} className="text-muted m-0 hstack gap-1">
                        <BiCategory style={{ marginTop: 2 }} /> {post?.categoryName}
                      </p>
                      <p style={{ fontSize: 14 }} className="text-muted m-0 hstack gap-1">
                        <MdOutlineArrowRightAlt style={{ marginTop: 2 }} /> {post?.subCategoryName}
                      </p>
                    </div>
                    <div style={{ fontSize: 14 }} className="text-muted hstack gap-2">
                      <RxCalendar />
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {post?.createdAt}
                      </Moment>
                    </div>
                  </div>
                  <h5 className="fw-bold">{post.title}</h5>
                  <p className="text-muted">{post.shortDescription}</p>

                  <Button
                    className="fw-semibold px-3"
                    style={{ fontSize: 12, backgroundColor: themeColor, borderColor: themeColor }}
                    size="sm"
                    onClick={() => { 
                      setPostData(post); 
                      toggles.setToggle();
                      sendNotification("notification", `Visitor Navigated to the ${post.title} Blog Post.`)
                    }}
                  >
                    View more →
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <PostDetails
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        postData={postData}
      />
    </div>
  );
};

export default BlogSection;
